












import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class TopstatsCounter extends Vue {
	@Prop() label!: string;
	@Prop() value!: string;
}
